const PAGE_LIMIT = 20;
const PAGE_LIMIT_ADMIN = 10;

export {
    PAGE_LIMIT,
    PAGE_LIMIT_ADMIN
};